import localPowerlearning from '@/modules/powerlearning/api/localPowerlearning'
import syncPowerlearning from '@/modules/powerlearning/api/syncPowerlearning'

export default function (store) {
  localPowerlearning.setup(store)
  syncPowerlearning.setup(store)
}
